import * as React from 'react';
import * as Sentry from '@sentry/react';

/** @NOTE-DP: This could have been react-query or smth... */
export const useQuery = <T>(
  fetcher: () => Promise<T>,
  initialValue: T,
  // @NOTE-DP: Caching key, must be unique for each distinct query, e.g. must include all query params
  key = '',
  skip = false,
  onError?: (e: Error) => void
): { data: T; loading: boolean; error: boolean } => {
  const [data, setData] = React.useState<T>(initialValue);
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState(false);
  React.useEffect(() => {
    let isSubscribed = true;

    // declare the async data fetching function
    const fetchData = async (): Promise<void> => {
      setLoading(true);
      setError(false);
      const fetchedData = await fetcher();
      if (isSubscribed) {
        setData(fetchedData);
        setLoading(false);
      }
    };

    if (!skip) {
      fetchData().catch((e) => {
        Sentry.captureException(e, { level: 'error' });
        setLoading(false);
        setError(true);
        onError?.(e);
      });
    }

    return (): void => {
      isSubscribed = false;
    };
  }, [key, skip]);
  return { data, loading: skip ? false : loading, error };
};
